import { render } from "./TransactionDetailModal.vue?vue&type=template&id=9befd412&scoped=true"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js"

import "./TransactionDetailModal.vue?vue&type=style&index=0&id=9befd412&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9befd412"]])

export default __exports__